/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { paymentMethodDestroy } from '../../axios/paymentMethodDestroy'
import type {
	PaymentMethodDestroyError,
	PaymentMethodDestroyPathParams,
	PaymentMethodDestroyResponse,
} from '../../types/PaymentMethodDestroy'

export const paymentMethodDestroyMutationKey = () => [{ url: '/:organisation/payment-methods/:paymentMethod' }] as const

export type PaymentMethodDestroyMutationKey = ReturnType<typeof paymentMethodDestroyMutationKey>

export type PaymentMethodDestroyVariables = {
	organisation: PaymentMethodDestroyPathParams['organisation']
	paymentMethod: PaymentMethodDestroyPathParams['paymentMethod']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::destroy */
export function usePaymentMethodDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		PaymentMethodDestroyResponse,
		AxiosError<PaymentMethodDestroyError>,
		PaymentMethodDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: paymentMethodDestroyMutationKey(),
		mutationFn: ({ organisation, paymentMethod }: PaymentMethodDestroyVariables) =>
			paymentMethodDestroy(organisation, paymentMethod, config).then(res => res.data),
		...options,
	})
}
